import { createStore } from 'vuex'
import auth from './modules/auth'
import posts from './modules/posts'
import blog from './modules/blog'

export default createStore({
  modules: {
    auth,
    posts,
    blog
  }
})